export default "__VITE_ASSET__00512a23__"